module.exports = __webpack_public_path__ + "static/media/video.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/video.mp4
// module id = 66
// module chunks = 0